import { dynamicPx, flexColumn, TextTypography, TitleTypography } from 'components/common/Common';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';
import { InfoIcon, SectionContainer } from '../JetSale.style';

const JetSaleContactContainer = styled(SectionContainer)`
  ${flexGap('0.5em')}
  margin: ${dynamicPx({ minSize: 40, maxSize: 120 })} 0;
`;

const Container = styled.article`
  display: flex;
  justify-content: space-between;
`;

const ContactContainer = styled.article`
  ${flexColumn}
  align-self: end;
  ${flexGap('2.5em')}

  border-radius: 0.5em;
  text-align: right;
  width: ${dynamicPx({ maxSize: 473, minSize: 320 })};
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const GoalContainer = styled.div`
  ${flexColumn}
  ${flexGap(dynamicPx({ maxSize: 40, minSize: 16 }))}

  width: 55%;
  border-radius: 8px;
  max-width: 620px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SecondContainer = styled(Container)`
  ${flexGap('1em')}

  align-items: flex-end;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const TextContainer = styled(Container)`
  margin: 8px 0;
`;

const SocialContainer = styled.div`
  margin-top: 1.5em;
  display: flex;
  ${flexGap('1.5em')}

  justify-content: space-between;
`;

const SocialButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5em 1em;
  ${flexGap('0.5em')}

  width: ${dynamicPx({ maxSize: 225, minSize: 140, minVW: 320 })};
  height: 40px;

  border: 2px solid #07080a;
  border-radius: 8px;

  &:hover {
    background-color: #07080a;

    * {
      color: var(--white);
    }
    img {
      filter: invert(1);
    }
  }
`;

const QRTooltip = styled(ReactTooltip)`
  border-radius: 1.5em !important;
  box-shadow: 0px 4px 56px rgba(77, 100, 126, 0.25);
  opacity: 1 !important;
  &::before,
  &::after {
    content: none !important;
  }
`;

const QRContent = styled.div`
  &::before {
    content: '';
    display: block;
    width: 80px;
    height: 2px;
    background: #0063db;
    margin: 1.875em auto 1em;
  }

  & > img {
    width: 20em;
    height: 20em;

    border-radius: 0.25em;
    margin: 0 auto 0.25em;
  }

  & > p {
    font-weight: normal;
    font-size: 1.125em;
    line-height: 1.375em;
    color: #07080a;
    text-align: center;
  }
`;

const JetSaleContact = () => {
  return (
    <JetSaleContactContainer>
      <SecondContainer>
        <GoalContainer>
          <TextTypography $maxSize={24} $minSize={14}>
            Our goal is not to sell you an airplane. It’s to provide you with the{' '}
            <b>best professional advice and services</b> on your aircraft purchase. We offer the{' '}
            <b>finest and latest pre-owned aircraft models</b>.
          </TextTypography>
          <TextTypography $maxSize={24} $minSize={14}>
            To <b>learn more</b> about why to buy an aircraft from Airacer, please contact us for a
            free consultation today.
          </TextTypography>
        </GoalContainer>
        <InfoIcon $dynamicSize={{ minSize: 64, maxSize: 120 }}>
          <img src={'/imgs/svg/downward-pointer.svg'} alt="downward-right-pointer" />
        </InfoIcon>
      </SecondContainer>
      <ContactContainer>
        <span style={{ fontSize: '36px', fontWeight: 600, lineHeight: 1 }}>
          Contact Information
        </span>
        <div>
          <TextContainer>
            <TextTypography step={-1}>Phone Numbers:</TextTypography>
            <TextTypography fontWeight={700} $color="#0063DB">
              +1(800)213-5051
            </TextTypography>
          </TextContainer>
          <TextContainer>
            <TextTypography step={-1}>Email:</TextTypography>
            <TextTypography fontWeight={700} $color="#0063DB">
              wen.wang@airacer.com
            </TextTypography>
          </TextContainer>
          <SocialContainer>
            <SocialButton href="https://wa.me/19295927248">
              <InfoIcon width={24} height={24}>
                <img src={'/imgs/svg/social/search-telephone.svg'} alt="Whats App" />
              </InfoIcon>
              <TextTypography step={-1}>WhatsApp</TextTypography>
            </SocialButton>

            <SocialButton data-tip data-for="qr-code">
              <InfoIcon width={24} height={24}>
                <img src={'/imgs/svg/social/logo-wechat.svg'} alt="logo wechat" />
              </InfoIcon>
              <TextTypography step={-1}>Wechat</TextTypography>
            </SocialButton>
            <QRTooltip
              id="qr-code"
              type="light"
              place="bottom"
              effect="solid"
              overridePosition={({ left, top }, _, _T, node) => {
                const d = document.documentElement;
                left = Math.min(d.clientWidth - node.clientWidth, left);
                top = Math.min(d.clientHeight - node.clientHeight, top);
                left = Math.max(0, left);
                top = Math.max(0, top);
                return { top, left };
              }}
            >
              <QRContent>
                <img
                  src={'https://qizhong19920114testbucket.s3.amazonaws.com/taxi-qr.png'}
                  alt="QR code"
                />
                <p>Contact us on Wechat</p>
              </QRContent>
            </QRTooltip>
          </SocialContainer>
        </div>
      </ContactContainer>
    </JetSaleContactContainer>
  );
};

export default JetSaleContact;
